import { createConfig, http } from "wagmi";
import { injected } from "wagmi/connectors";
import { arc } from "./chain";

// Browser injected wallets only (MetaMask, Rabby, Coinbase Wallet, ...)
// via EIP-1193 / EIP-6963 discovery. No WalletConnect project ID required.
export const wagmiConfig = createConfig({
  chains: [arc],
  connectors: [injected()],
  transports: { [arc.id]: http("https://rpc.arc-scan.org") },
  multiInjectedProviderDiscovery: true,
});
